const setUserDataApi = (data = {}) => {
    const { users = [] } = data,
        [firstUser = {}] = users;
    return firstUser;
}
export default setUserDataApi;